export const enTranslations = {
  PER_PAGE: 'per page',
  OF: 'of',
  ITEMS: 'items',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
};
